import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AddPackageService } from '../add-package/add-package.service';
import { AddVehiclesService } from '../add-vehicles/add-vehicles.service';
import { PackageService } from '../package/package.service';
import { ViewPackageDetailsService } from '../view-package-details/view-package-details.service';

@Component({
  selector: 'app-edit-package',
  templateUrl: './edit-package.component.html',
  styleUrls: ['./edit-package.component.sass']
})
export class EditPackageComponent implements OnInit {
  senderName="";
  receiverName="";
  senderMobile="";
  receiverMobile="";
  senderEmail="";
  receiverEmail="";
  senderAddress="";
  receiverAddress="";
  senderLatitude="";
  senderLongtitude="";
  receiverLatitude="";
  receiverLongtitude="";
  country="";
  state="";
  city="";
  shipmentType="";
  distance="";
  goodsDescription="";
  nosPackage="";
  packageDeliveryPrice="";
  packageWeight="";
  goodsDimension="";
  specialInstructions="";

  // isSendBySMS=true;
  // isSendByEMAIL=false;

  paymentID="";
  paymentMethod="";
  paymentTotalAmount="";
  walletAmount="";
  paymentStatus:any;


  directionsService:any;
  directionsRenderer:any;

  stopsBtn=true;
  closeResult: string;

  vehicleId="";
  vehicleName="";
  vehicleImage="";

  stopReceiverName="";
  stopReceiverNo="";
  stopReceiverAddress="";
  stopReceiverLatitude="";
  stopReceiverLongtitude="";
  stopageArray=[];

  allVehiclesList="";
  selectedVehicleData:any;
  couponCode="";
  isCouponValid=false;

  fareTip:any="";
  labourCost:any = "";
  couponCost:any ="";
  netFare:any ="";
  totalAmount:any ="";


  packageId:any;
  packageID:any;
  editPackageData:any;

  constructor(public activatedRoute: ActivatedRoute,
    private spinner : NgxSpinnerService,
    private router: Router,
    private editPackageService :ViewPackageDetailsService,
    private toastr:ToastrService,
    private addpackageService:AddPackageService,
    private modalService: NgbModal,
    private packageService : PackageService,
    private addvehicelService : AddVehiclesService) { }

  ngOnInit(): void {
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();

    
    this.packageId=this.activatedRoute.snapshot.queryParams.id;
    console.log(this.packageId)
    this.getPackageById()
    this.getAllVehicles()
  }


  getPackageById(){
    this.spinner.show();
    let data = {
      "id" : this.packageId
    }
    this.editPackageService.getPackageById(data).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide()
        this.editPackageData = result.data;
        console.log(this.editPackageData)
        this.packageId
        this.packageID= this.editPackageData.packageID;
        this.senderName = this.editPackageData.senderName
        this.receiverName = this.editPackageData.receiverName;
        this.senderMobile = this.editPackageData.senderMobile;
        this.receiverMobile = this.editPackageData.receiverMobile;
        this.senderEmail = this.editPackageData.senderEmail;
        this.receiverEmail = this.editPackageData.receiverEmail;
        this.senderAddress = this.editPackageData.fromAddress;
        this.receiverAddress = this.editPackageData.toAddress;
        this.senderLatitude = this.editPackageData.fromLatitude;
        this.receiverLatitude = this.editPackageData.toLatitude;
        this.senderLongtitude = this.editPackageData.fromLongitude;
        this.receiverLongtitude = this.editPackageData.toLongitude;
        this.city = this.editPackageData.city;
        this.country = this.editPackageData.country;
        this.shipmentType = this.editPackageData.shipmentType;
        this.goodsDescription = this.editPackageData.goodsDescription;
        this.nosPackage = this.editPackageData.noOfPackages;
        this.packageDeliveryPrice = this.editPackageData.priceForPackageDelivery;
        this.packageWeight = this.editPackageData.goodsWeightKg;
        this.distance = this.editPackageData.distance;
        this.goodsDimension = this.editPackageData.goodsDimension;
        this.specialInstructions = this.editPackageData.specialInstructions;
        // this.isSendBySMS = this.editPackageData.sendBySms;
        // this.isSendByEMAIL = this.editPackageData.sendByEmail;
        // this.vehicleName = "OPENMODAL"
        this.fareTip = this.editPackageData.billDetails.fareTip;
        this.labourCost = this.editPackageData.billDetails.labourCost;
        this.couponCost = this.editPackageData.billDetails.couponDiscount;
        this.netFare = this.editPackageData.billDetails.netFare;
        this.gstOnFareTip=this.editPackageData.tripFareGST;
        this.convinienceFee=this.editPackageData.convenienceWithoutGST;
        this.gstOnconvinienceFee=this.editPackageData.convenienceGST;
        this.labourCost=this.editPackageData.helperTotalAmt;
        this.gstOnlabourCost=this.editPackageData.helperGST;
        this.totalAmount =  this.editPackageData.billDetails.totalAmount;
        this.paymentID = this.editPackageData.paymentDetails.paymentId ;
        this.paymentMethod = this.editPackageData.paymentDetails.paymentMethod ;
        this.paymentTotalAmount = this.editPackageData.paymentDetails.totalAmount ;
        this.walletAmount = this.editPackageData.paymentDetails.walletAmount ;
        this.paymentStatus = this.editPackageData.paymentDetails.status ;


        }else{
        this.spinner.hide()
        this.toastr.error(result.message);
      }
    })
}

getAllVehicles(){
  this.spinner.show();
  let data = { isDeleted : 0 }
  this.addpackageService.getAllVehicle(data).subscribe((result:any)=>{
    this.spinner.hide();
    if(result.statusCode == 200){
      this.spinner.hide();
      this.allVehiclesList  = result.data;
      console.log("vehicleTypes", this.allVehiclesList)
    }else{  
      this.spinner.hide();
      this.toastr.error(result.message)
    }
  })
}



 // Select image code start
//  isValidImage: any;
//  imageUrl = "";
//  isImageUploaded=false;
//  getVehicleImage(event) {
//    if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
//      this.isValidImage = false;
//      // var files = event.target.files;
//      // var file = event[0];

//        this.addvehicelService.addImage(event.target.files[0]).subscribe((result:any)=>{
//          console.log(result)
//          if(result.statusCode == 200){
//              this.isImageUploaded = true;
//              this.imageUrl = result.photoUrl;
//          }else{
//            this.isImageUploaded = false;
//            this.imageUrl = "";
//          }
//          this.isValidImage = false;
//        })

//    } else {
//      this.isValidImage = true;
//      this.isImageUploaded = false;
//    }
//  }


updatePackage(){
  let data = {
    "id" :this.packageId,
    "deviceToken" : "",
    "fromAddress" : this.senderAddress,
    "toAddress" : this.receiverAddress,
    "fromLatitude" : this.senderLatitude,
    "fromLongitude" : this.senderLongtitude,
    "toLatitude" : this.receiverLatitude , 
    "toLongitude" : this.receiverLongtitude,
    "senderName" : this.senderName , 
    "senderMobile" : this.senderMobile,
    "senderEmail" : this.senderEmail,
    "receiverName" : this.receiverName,
    "receiverMobile" : this.receiverMobile,
    "receiverEmail" : this.receiverEmail,
    "city" : this.city,
    "state" : this.state,
    "country" : this.country,
    // "specialInstructions" : this.specialInstructions,
    "goodsDescription" : this.goodsDescription,
    "shipmentType" : this.shipmentType,
    // "priceForPackageDelivery" : this.packageDeliveryPrice,
    // "sendBySms" : this.isSendBySMS,
    // "sendByEmail" : this.isSendByEMAIL,
    "noOfPackages" : this.nosPackage,
    "distance" : this.distance,
    "goodsDimension" : this.goodsDimension,
    "goodsWeightKg"  : this.packageWeight,
    // "stops": {
    //     "stop1": {
    //       "address": this.stopageArray[0]? this.stopageArray[0].address : "",
    //       "latitude": this.stopageArray[0]? this.stopageArray[0].latitude : "",
    //       "longitude": this.stopageArray[0]? this.stopageArray[0].longitude : "",
    //       "receiverName": this.stopageArray[0]? this.stopageArray[0].receiverName : "",
    //       "receiverPhoneNo": this.stopageArray[0]? this.stopageArray[0].receiverPhoneNo : ""
    //     },
    //     "stop2": {
    //       "address": this.stopageArray[1]? this.stopageArray[1].address : "",
    //       "latitude": this.stopageArray[1]? this.stopageArray[1].latitude : "",
    //       "longitude": this.stopageArray[1]? this.stopageArray[1].longitude : "",
    //       "receiverName": this.stopageArray[1]? this.stopageArray[1].receiverName : "",
    //       "receiverPhoneNo": this.stopageArray[1]? this.stopageArray[1].receiverPhoneNo : ""
    //     },
    //     "stop3": {
    //       "address": this.stopageArray[2]? this.stopageArray[2].address : "",
    //       "latitude": this.stopageArray[2]? this.stopageArray[2].latitude : "",
    //       "longitude": this.stopageArray[2]? this.stopageArray[2].longitude : "",
    //       "receiverName": this.stopageArray[2]? this.stopageArray[2].receiverName : "",
    //       "receiverPhoneNo": this.stopageArray[2]? this.stopageArray[2].receiverPhoneNo : ""
    //     },
    //     "stop4": {
    //       "address": this.stopageArray[3]? this.stopageArray[3].address : "",
    //       "latitude": this.stopageArray[3]? this.stopageArray[3].latitude : "",
    //       "longitude": this.stopageArray[3]? this.stopageArray[3].longitude : "",
    //       "receiverName": this.stopageArray[3]? this.stopageArray[3].receiverName : "",
    //       "receiverPhoneNo": this.stopageArray[3]? this.stopageArray[3].receiverPhoneNo : ""
    //     }
    // },
  //   "billDetails" : {
  //     "fareTip": this.fareTip,
  //     "labourCost": this.labourCost,
  //     "couponDiscount": this.couponCost,
  //     "netFare": this.netFare,
  //     "totalAmount": this.totalAmount
  //   },
  //   "paymentDetails": {
  //     "paymentId": "1234",
  //     "paymentMethod": "Paytm",
  //     "status": 1,
  //     "walletAmount": 500,
  //     "totalAmount": 1600
  // },
    // "goldMembership" : 0,
    // "photos" : this.imageUrl,
    "vehicleId": this.vehicleId,
    "vehicleImage": this.vehicleImage,
    // "vehicleName": this.vehicleName,
    // "cancelReason": "",
    // "helperOption": this.labourCost ? true : false,
    // "helperBasicAmount": this.labourCost ? this.labourCost : 0,
    // "driverId" :  "",
      // "signatureStatus" : false
  }
  console.log(data)
  this.spinner.show()
  this.packageService.updatePackage(data).subscribe((result:any)=>{
    if(result.statusCode == 200){
      this.spinner.hide();
      this.toastr.success(result.message);
      this.getPackageById()
    }else{
      this.spinner.hide()
      this.toastr.error(result.message)
    }
  })
}


isLabourAvailable=false;
labourStatus=false;
getSelectedVehicle(data){
  if(data){
    this.selectedVehicleData = {};
     this.selectedVehicleData = JSON.parse(data);
    console.log(this.selectedVehicleData)
    this.vehicleId = this.selectedVehicleData._id;
    // this.vehicleName = this.selectedVehicleData.vehicleName;
    this.vehicleImage = this.selectedVehicleData.images;
    this.isLabourAvailable = this.selectedVehicleData.labourAvailable; 
    this.labourStatus = this.selectedVehicleData.labourAvailable;
    this.isCouponValid = false;
    // this.calculateBillDetails();
  }else{
    // this.vehicleName ="";
    this.isLabourAvailable = false;
  }
}
gstOnFareTip:any;
convinienceFee:any;
gstOnconvinienceFee:any;
gstOnlabourCost:any;
// calculateBillDetails(){

//   let labour_cost  = this.isLabourAvailable  == true ? environment.labourCost : 0;
//   let coupon_cost = this.isCouponValid == true ? Number(this.selectedVehicleData.originalPrice)-Number(this.selectedVehicleData.discountedPrice) : 0;
//   let originalPrice = Number(this.selectedVehicleData.originalPrice)

//   this.fareTip = originalPrice  ;
//   this.gstOnFareTip=this.fareTip*18/100
//   this.labourCost =this.isLabourAvailable  == true ? environment.labourCost : 0;
//   this.gstOnlabourCost=this.labourCost*18/100;
//   this.couponCost = this.isCouponValid == true ? environment.couponCost : 0;
//   this.convinienceFee=60;
//   this.gstOnconvinienceFee=this.convinienceFee*18/100;
//   this.netFare = originalPrice +  labour_cost + this.gstOnFareTip+this.gstOnlabourCost+this.gstOnconvinienceFee+this.convinienceFee- coupon_cost;  ;
//   this.totalAmount = originalPrice +  labour_cost + this.gstOnFareTip+this.gstOnlabourCost+this.gstOnconvinienceFee+this.convinienceFee- coupon_cost;
// }




getSenderAddress(address:any){
  var country , state , city;
  if(address.address_components.length == 3){
    country = address.address_components[2].long_name,
    state = address.address_components[1].long_name
    city = address.address_components[0].long_name
  }else if(address.address_components.length == 4){
    country = address.address_components[3].long_name,
    state = address.address_components[2].long_name
    city = address.address_components[1].long_name
    city = address.address_components[0].long_name
  }else if(address.address_components.length == 5){
    country = address.address_components[4].long_name,
    state = address.address_components[3].long_name
    city = address.address_components[2].long_name
  }else if(address.address_components.length == 6){
    country = address.address_components[4].long_name,
    state = address.address_components[3].long_name
    city = address.address_components[2].long_name
  }
  // let sendData = {
  //   "city" : city,
  //   "state" : state,
  //   "country" : country
  // }
  // this.spinner.show();
  // this.addpackageService.checkVerifyCity(sendData).subscribe((result:any)=>{
  //   if(result.statusCode == 200){
  //     this.spinner.hide();
      this.senderAddress = address.name;
      this.senderLatitude = address.geometry.location.lat()
      this.senderLongtitude = address.geometry.location.lng()
      this.calculateDistanceBwLatLong()
  //     console.log('this.senderAddress  ',this.senderAddress)
  //   }else{
  //     this.spinner.hide();
  //     this.toastr.error("City Not Verified");
  //     this.distance = "";
  //   }
  // })


}


getReceiverAddress(address:any){
  if(address.address_components.length == 3){
    this.country = address.address_components[2].long_name;
    this.state = address.address_components[1].long_name;
    this.city = address.address_components[0].long_name;
  }else if(address.address_components.length == 4){
    this.country = address.address_components[3].long_name,
    this.state = address.address_components[2].long_name
    this.city = address.address_components[1].long_name
  }else if(address.address_components.length == 5){
    this.country = address.address_components[4].long_name,
    this.state = address.address_components[3].long_name
    this.city = address.address_components[2].long_name
  }else if(address.address_components.length == 6){
    this.country = address.address_components[4].long_name,
    this.state = address.address_components[3].long_name
    this.city = address.address_components[1].long_name
  }
  // let sendData = {
  //   "city" : this.city,
  //   "state" : this.state,
  //   "country" : this.country
  // }
  // this.spinner.show();
  // this.addpackageService.checkVerifyCity(sendData).subscribe((result:any)=>{
  //   if(result.statusCode == 200){
  //     this.spinner.hide();
      this.receiverAddress = address.name;
      this.receiverLatitude = address.geometry.location.lat()
      this.receiverLongtitude = address.geometry.location.lng()
      this.calculateDistanceBwLatLong()
  //   }else{
  //     this.spinner.hide();
  //     this.toastr.error("City Not Verified")
  //     this.city = "";
  //     this.state = "";
  //     this.country = "";
  //     this.distance = "";
  //   }
  // })

}

getStopageReceiverAddress(address){
  var country , state , city;
  if(address.address_components.length == 3){
    country = address.address_components[2].long_name,
    state = address.address_components[1].long_name
    city = address.address_components[0].long_name
  }else if(address.address_components.length == 4){
    country = address.address_components[3].long_name,
    state = address.address_components[2].long_name
    city = address.address_components[1].long_name
  }else if(address.address_components.length == 5){
    country = address.address_components[4].long_name,
    state = address.address_components[3].long_name
    city = address.address_components[2].long_name
  }else if(address.address_components.length == 6){
    country = address.address_components[4].long_name,
    state = address.address_components[3].long_name
    city = address.address_components[1].long_name
  }
  // let sendData = {
  //   "city" : city,
  //   "state" : state,
  //   "country" : country
  // }
  // this.spinner.show()
  // this.addpackageService.checkVerifyCity(sendData).subscribe((result:any)=>{
  //       if(result.statusCode == 200){
          // this.spinner.hide();
          this.stopReceiverAddress = address.name;
          this.stopReceiverLatitude = address.geometry.location.lat()
          this.stopReceiverLongtitude = address.geometry.location.lng()
  //       }else{
  //         this.spinner.hide();
  //         this.toastr.error("City not verified");
  //         this.stopReceiverLatitude = "";
  //         this.stopReceiverLongtitude = "";
  //         this.stopReceiverAddress=""
  //       }
  // })



}

disabledAllStopField=false;
addStopage(){
    let data = {
      "address" : this.stopReceiverAddress , 
      "latitude" : this.stopReceiverLatitude,
      "longitude" : this.stopReceiverLongtitude,
      "receiverName" : this.stopReceiverName,
      "receiverPhoneNo" : this.stopReceiverNo
    }
    this.stopageArray.push(data);
    this.stopReceiverAddress  = "";
    this.stopReceiverLatitude = "";
    this.stopReceiverLongtitude = "";
    this.stopReceiverName = "";
    this.stopReceiverNo = "";
    if(this.stopageArray.length >= 4){
        this.disabledAllStopField = true;
    }else{
      this.disabledAllStopField = false;
    }
    console.log( this.stopageArray)
}

removeStopage(data){
  var index = this.stopageArray.indexOf(data);
  this.stopageArray.splice(index, 1); // Removes one element, starting from index
  this.disabledAllStopField = false;
  console.log(this.stopageArray)
}




async calculateDistanceBwLatLong(){
  if(this.senderAddress && this.receiverAddress){
    // this.stopsBtn = true;
    this.directionsService.route({
      origin: this.senderAddress,
      destination: this.receiverAddress,
      travelMode: 'DRIVING'
    })   .then((response) => {
      this.directionsRenderer.setDirections(response);
      this.distance = response.routes[0].legs[0].distance.text
    }) .catch((e) =>  { 
      this.toastr.error("Directions request failed due to " )
      this.distance="";
      this.stopsBtn = false;
    } );
  
}else{
  this.distance="";
  this.stopsBtn = false;
}
}


// sendBySMS(value:any){
// this.isSendBySMS = value;
// }

// sendByEMAIL(value:any){
// this.isSendByEMAIL = value;
// }

checkLabour(value:any){
this.isLabourAvailable = value;
// this.calculateBillDetails();
}


applyCoupon() {
  if (this.vehicleName) {
    const couponNumber = "1234";
    if (this.couponCode == couponNumber) {
      this.toastr.success("Coupon valid");
      this.isCouponValid = true;
      // this.calculateBillDetails()
    } else {
      this.toastr.error("Oops, Coupon Invalid");
      this.isCouponValid = false;
    }
  } else {
    this.toastr.error("Please select vehicle")
  }
}



openStopModal(content){
  var stopageArrayData :any ; 
  this.stopageArray = [];
  stopageArrayData = Object.entries(this.editPackageData.stops);

    for(let i=0; i<stopageArrayData.length; i++){
      if(stopageArrayData[i][1].address != "" ){
        let data = {
          "address" : stopageArrayData[i][1].address,
          "latitude" : stopageArrayData[i][1].latitude,
          "longitude" : stopageArrayData[i][1].longitude,
          "receiverName" : stopageArrayData[i][1].receiverName,
          "receiverPhoneNo" : stopageArrayData[i][1].receiverPhoneNo
        }
        this.stopageArray.push(data)
        console.log(this.stopageArray)
      }
    }
    if(this.stopageArray.length >= 4){
      this.disabledAllStopField = true;
  }else{
    this.disabledAllStopField = false;
  }
  this.openModal(content);
}


openModal(content) {
  this.modalService.open(content , {size : "lg"}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}
}
